// Static registration manifest for all Ui:: Stimulus controllers EXCEPT
// ui--chart, which lives in the chart add-on entry (../../chart.js): its
// controller lazy-imports "chart.js/auto" (~441 KB unminified, ~211 KB minified), and esbuild hosts that
// bundle without --splitting would inline that into their main bundle as long
// as the controller stayed reachable from here. Hosts with chart pages load
// the add-on entry explicitly and call registerConekUiChartController.
// Import once in the host app:
//   import { registerConekUiControllers } from "@a-safe-digital/conek-ui"
//   registerConekUiControllers(application)
//
// Generated from the controllers in this directory; keep in sync when adding one.

import AccordionController from "./accordion_controller";
import AccordionGroupController from "./accordion_group_controller";
import AccordionTriggerController from "./accordion_trigger_controller";
import AdminLayoutController from "./admin_layout_controller";
import AiFieldHelperController from "./ai_field_helper_controller";
import AlertController from "./alert_controller";
import AppearanceController from "./appearance_controller";
import FormatDatetimeController from "./format_datetime_controller";
import AutoSubmitController from "./auto_submit_controller";
import AutomationActionBuilderController from "./automation/action_builder_controller";
import AutomationConditionBuilderController from "./automation/condition_builder_controller";
import BreadcrumbsCollapseController from "./breadcrumbs_collapse_controller";
import CalendarEditableGridController from "./calendar/editable_grid_controller";
import CalendarKeyboardNavController from "./calendar/keyboard_nav_controller";
import CalendarNowLineTickController from "./calendar/now_line_tick_controller";
import CheckboxController from "./checkbox_controller";
import ColorPickerToHslController from "./color_picker_to_hsl_controller";
import ComboBoxController from "./combo_box_controller";
import ConfirmSubmitController from "./confirm_submit_controller";
import ExpressionInputController from "./expression_input_controller";
import CommandPaletteController from "./command_palette_controller";
import CopyButtonController from "./copy_button_controller";
import TextareaCounterController from "./textarea_counter_controller";
import DashboardAbBannerController from "./dashboard_ab_banner_controller";
import DataTableController from "./data_table_controller";
import DatePickerController from "./date_picker_controller";
import DatepickerController from "./datepicker_controller";
import DeleteVerificationController from "./delete_verification_controller";
import DependentFrameController from "./dependent_frame_controller";
import DraggableListController from "./draggable_list_controller";
import DrawerController from "./drawer_controller";
import DrawerOpenerController from "./drawer_opener_controller";
import DropdownController from "./dropdown_controller";
import DropdownMenuController from "./dropdown_menu_controller";
import EntitySelectorController from "./entity_selector_controller";
import FacilitiesLocationCascadeController from "./facilities/location_cascade_controller";
import FileInputController from "./file_input_controller";
import FloatingMenuController from "./floating_menu_controller";
import FlowBackgroundController from "./flow/background_controller";
import FlowConnectionLineController from "./flow/connection_line_controller";
import FlowContextMenuController from "./flow/context_menu_controller";
import FlowController from "./flow/flow_controller";
import FlowDndNodeController from "./flow/dnd_node_controller";
import FlowDndPaletteFilterController from "./flow/dnd_palette_filter_controller";
import FlowDropzoneController from "./flow/dropzone_controller";
import FlowEdgeController from "./flow/edge_controller";
import FlowEdgeToolbarController from "./flow/edge_toolbar_controller";
import FlowExportController from "./flow/flow_export_controller";
import FlowHandleController from "./flow/handle_controller";
import FlowInspectController from "./flow/flow_inspect_controller";
import FlowLayoutController from "./flow/layout_controller";
import FlowMinimapController from "./flow/minimap_controller";
import FlowNodeController from "./flow/node_controller";
import FlowNodeResizerController from "./flow/node_resizer_controller";
import FlowNodeToolbarController from "./flow/node_toolbar_controller";
import FlowPanelController from "./flow/panel_controller";
import FlowPersistController from "./flow/flow_persist_controller";
import FlowRunTimelineController from "./flow/run_timeline_controller";
import FlowStatusBarController from "./flow/status_bar_controller";
import FlowStoryController from "./flow/flow_story_controller";
import FlowSyncController from "./flow/flow_sync_channel";
import FlowTimelineController from "./flow/timeline_controller";
import FlowToolbarBarController from "./flow/toolbar_bar_controller";
import FlowToolbarController from "./flow/toolbar_controller";
import FlowUrlStateController from "./flow/flow_url_state_controller";
import FrameBusyController from "./frame_busy_controller";
import ImagePreviewController from "./image_preview_controller";
import InheritedStateController from "./inherited_state_controller";
import LightboxController from "./lightbox_controller";
import MediaLibraryController from "./media_library_controller";
import MediaPickerController from "./media_picker_controller";
import MobileFabMenuController from "./mobile/fab_menu_controller";
import MobileInfiniteScrollController from "./mobile/infinite_scroll_controller";
import ModalController from "./modal_controller";
import ModalOpenerController from "./modal_opener_controller";
import MultiSelectController from "./multi_select_controller";
import NotificationsController from "./notifications_controller";
import ObservabilityWaterfallController from "./observability/waterfall_controller";
import PillController from "./pill_controller";
import PopoverController from "./popover_controller";
import PreservedParamsController from "./preserved_params_controller";
import ProfilePictureController from "./profile_picture_controller";
import RangeSliderController from "./range_slider_controller";
import ReferenceDataConfirmController from "./reference_data_confirm_controller";
import SecretFieldController from "./secret_field_controller";
import SchemaFormController from "./schema_form_controller";
import SelectController from "./select_controller";
import SelectEntityModalController from "./select_entity_modal_controller";
import SidebarController from "./sidebar_controller";
import SpaceSelectorController from "./space_selector_controller";
import SpaceSelectorFormController from "./space_selector_form_controller";
import StickyHeaderController from "./sticky_header_controller";
import SwipeDeckController from "./swipe_deck_controller";
import TableController from "./table_controller";
import TabsController from "./tabs_controller";
import TabsScrollController from "./tabs_scroll_controller";
import TagInputSortableController from "./tag_input_sortable_controller";
import TextEditorController from "./text_editor_controller";
import TextEditorSupportController from "./text_editor_support_controller";
import TimePickerController from "./time_picker_controller";
import TimePickerScrollableController from "./time_picker_scrollable_controller";
import TimeRangePickerController from "./time_range_picker_controller";
import ToastController from "./toast_controller";
import ToggleController from "./toggle_controller";
import TooltipController from "./tooltip_controller";
import TreeController from "./tree_controller";
import UnlockKeyController from "./unlock_key_controller";
import UrlSyncController from "./url_sync_controller";
import BacklogController from "./work/backlog_controller";
import BoardController from "./work/board_controller";
import CellEditorController from "./work/cell_editor_controller";
import CommentsController from "./work/comments_controller";
// W12 (dashboards): the ONE new JS identifier this wave adds (W12-D8) —
// a single additive import + registration, the append-only manifest rule.
import DashboardGridController from "./work/dashboard_grid_controller";
import EditableTableController from "./work/editable_table_controller";
import WorkIssueComposerController from "./work/issue_composer_controller";
import WorkIssueController from "./work/issue_controller";
import WorkIssueFieldController from "./work/issue_field_controller";
import WorkIssueTransitionsController from "./work/issue_transitions_controller";
import WorkIssueUrlStateController from "./work/issue_url_state_controller";
import WorkNavigatorController from "./work/navigator_controller";
import WorkNavigatorUrlStateController from "./work/navigator_url_state_controller";
import WorkPageTreeDragController from "./work/page_tree_drag_controller";
import WorkSelectionController from "./work/selection_controller";
import WorkTimelineController from "./work/timeline_controller";
import WorkCardController from "./work/work_card_controller";
import WorkDragController from "./work/work_drag_controller";
import WorkGridGroupsController from "./work/work_grid_groups_controller";
import WorkViewStateController from "./work/work_view_state_controller";

const CONTROLLERS = {
  "ui--accordion": AccordionController,
  "ui--accordion-group": AccordionGroupController,
  "ui--accordion-trigger": AccordionTriggerController,
  "ui--admin-layout": AdminLayoutController,
  "ui--ai-field-helper": AiFieldHelperController,
  "ui--alert": AlertController,
  "ui--appearance": AppearanceController,
  "ui--auto-submit": AutoSubmitController,
  "ui--format-datetime": FormatDatetimeController,
  "ui--automation--action-builder": AutomationActionBuilderController,
  "ui--automation--condition-builder": AutomationConditionBuilderController,
  "ui--breadcrumbs-collapse": BreadcrumbsCollapseController,
  "ui--calendar--editable-grid": CalendarEditableGridController,
  "ui--calendar--keyboard-nav": CalendarKeyboardNavController,
  "ui--calendar--now-line-tick": CalendarNowLineTickController,
  "ui--checkbox": CheckboxController,
  "ui--color-picker-to-hsl": ColorPickerToHslController,
  "ui--combo-box": ComboBoxController,
  "ui--confirm-submit": ConfirmSubmitController,
  "ui--expression-input": ExpressionInputController,
  "ui--command-palette": CommandPaletteController,
  "ui--copy-button": CopyButtonController,
  "ui--textarea-counter": TextareaCounterController,
  "ui--dashboard-ab-banner": DashboardAbBannerController,
  "ui--data-table": DataTableController,
  "ui--date-picker": DatePickerController,
  "ui--datepicker": DatepickerController,
  "ui--delete-verification": DeleteVerificationController,
  "ui--dependent-frame": DependentFrameController,
  "ui--draggable-list": DraggableListController,
  "ui--drawer": DrawerController,
  "ui--drawer-opener": DrawerOpenerController,
  "ui--dropdown": DropdownController,
  "ui--dropdown-menu": DropdownMenuController,
  "ui--entity-selector": EntitySelectorController,
  "ui--facilities--location-cascade": FacilitiesLocationCascadeController,
  "ui--file-input": FileInputController,
  "ui--floating-menu": FloatingMenuController,
  "ui--flow": FlowController,
  "ui--flow-background": FlowBackgroundController,
  "ui--flow-connection-line": FlowConnectionLineController,
  "ui--flow-context-menu": FlowContextMenuController,
  "ui--flow-dnd-node": FlowDndNodeController,
  "ui--flow-dnd-palette-filter": FlowDndPaletteFilterController,
  "ui--flow-dropzone": FlowDropzoneController,
  "ui--flow-edge": FlowEdgeController,
  "ui--flow-edge-toolbar": FlowEdgeToolbarController,
  "ui--flow-export": FlowExportController,
  "ui--flow-handle": FlowHandleController,
  "ui--flow-inspect": FlowInspectController,
  "ui--flow-layout": FlowLayoutController,
  "ui--flow-minimap": FlowMinimapController,
  "ui--flow-node": FlowNodeController,
  "ui--flow-node-resizer": FlowNodeResizerController,
  "ui--flow-node-toolbar": FlowNodeToolbarController,
  "ui--flow-panel": FlowPanelController,
  "ui--flow-persist": FlowPersistController,
  "ui--flow-run-timeline": FlowRunTimelineController,
  "ui--flow-status-bar": FlowStatusBarController,
  "ui--flow-story": FlowStoryController,
  "ui--flow-sync": FlowSyncController,
  "ui--flow-timeline": FlowTimelineController,
  "ui--flow-toolbar": FlowToolbarController,
  "ui--flow-toolbar-bar": FlowToolbarBarController,
  "ui--flow-url-state": FlowUrlStateController,
  "ui--frame-busy": FrameBusyController,
  "ui--image-preview": ImagePreviewController,
  "ui--inherited-state": InheritedStateController,
  "ui--lightbox": LightboxController,
  "ui--media-library": MediaLibraryController,
  "ui--media-picker": MediaPickerController,
  "ui--mobile--fab-menu": MobileFabMenuController,
  "ui--mobile--infinite-scroll": MobileInfiniteScrollController,
  "ui--modal": ModalController,
  "ui--modal-opener": ModalOpenerController,
  "ui--multi-select": MultiSelectController,
  "ui--notifications": NotificationsController,
  "ui--observability--waterfall": ObservabilityWaterfallController,
  "ui--pill": PillController,
  "ui--popover": PopoverController,
  "ui--preserved-params": PreservedParamsController,
  "ui--profile-picture": ProfilePictureController,
  "ui--range-slider": RangeSliderController,
  "ui--reference-data-confirm": ReferenceDataConfirmController,
  "ui--schema-form": SchemaFormController,
  "ui--secret-field": SecretFieldController,
  "ui--select": SelectController,
  "ui--select-entity-modal": SelectEntityModalController,
  "ui--sidebar": SidebarController,
  "ui--space-selector": SpaceSelectorController,
  "ui--space-selector-form": SpaceSelectorFormController,
  "ui--sticky-header": StickyHeaderController,
  "ui--swipe-deck": SwipeDeckController,
  "ui--table": TableController,
  "ui--tabs": TabsController,
  "ui--tabs-scroll": TabsScrollController,
  "ui--tag-input-sortable": TagInputSortableController,
  "ui--text-editor": TextEditorController,
  "ui--text-editor-support": TextEditorSupportController,
  "ui--time-picker": TimePickerController,
  "ui--time-picker-scrollable": TimePickerScrollableController,
  "ui--time-range-picker": TimeRangePickerController,
  "ui--toast": ToastController,
  "ui--toggle": ToggleController,
  "ui--tooltip": TooltipController,
  "ui--tree": TreeController,
  "ui--unlock-key": UnlockKeyController,
  "ui--url-sync": UrlSyncController,
  "ui--work-backlog": BacklogController,
  "ui--work-board": BoardController,
  "ui--work-card": WorkCardController,
  "ui--work-cell-editor": CellEditorController,
  "ui--work-comments": CommentsController,
  "ui--work-drag": WorkDragController,
  "ui--work-editable-table": EditableTableController,
  "ui--work-gadget-grid": DashboardGridController,
  "ui--work-grid-groups": WorkGridGroupsController,
  "ui--work-issue": WorkIssueController,
  "ui--work-issue-composer": WorkIssueComposerController,
  "ui--work-issue-field": WorkIssueFieldController,
  "ui--work-issue-transitions": WorkIssueTransitionsController,
  "ui--work-issue-url-state": WorkIssueUrlStateController,
  "ui--work-navigator": WorkNavigatorController,
  "ui--work-navigator-url-state": WorkNavigatorUrlStateController,
  "ui--work-page-tree": WorkPageTreeDragController,
  "ui--work-selection": WorkSelectionController,
  "ui--work-timeline": WorkTimelineController,
  "ui--work-view-state": WorkViewStateController,
};

export function registerConekUiControllers(application) {
  for (const [name, controller] of Object.entries(CONTROLLERS)) {
    application.register(name, controller);
  }
}
